import { render, staticRenderFns } from "./IndustrialPropertyFormEditor.vue?vue&type=template&id=2fc70d5b"
import script from "./IndustrialPropertyFormEditor.vue?vue&type=script&lang=js"
export * from "./IndustrialPropertyFormEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports